var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBq(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:52234)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.001C24.8366 32.001 32 24.8375 32 16.001C32 7.16442 24.8366 0.000976562 16 0.000976562C7.16344 0.000976562 0 7.16442 0 16.001C0 24.8375 7.16344 32.001 16 32.001Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.68618 4.68723C1.25711 8.11629 -0.289573 12.7147 0.0449895 17.1988L17.1977 0.0461034C12.7136 -0.288522 8.11524 1.25817 4.68618 4.68723V4.68723Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71313 28.2555C11.9994 33.5444 21.3969 33.2315 27.3138 27.3147C33.2306 21.3979 33.5434 12.0004 28.2545 5.71417L5.71313 28.2555Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9429 15.3565L17.3217 14.6096L15.9429 13.8628C15.621 11.7715 13.9686 10.119 11.8773 9.79715L11.1303 8.41827L10.3835 9.79709C8.29221 10.119 6.63984 11.7714 6.31784 13.8627L4.93896 14.6096L6.31778 15.3565C6.63971 17.4478 8.29209 19.1003 10.3834 19.4221L11.1303 20.801L11.8772 19.4222C13.9686 19.1003 15.621 17.4478 15.9429 15.3565V15.3565ZM11.1304 17.3923C9.59358 17.3923 8.34777 16.1465 8.34777 14.6096C8.34777 13.0728 9.59352 11.827 11.1304 11.827C12.6673 11.827 13.913 13.0728 13.913 14.6096C13.913 16.1465 12.6672 17.3923 11.1304 17.3923Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1306 12.5228L11.733 13.5663H12.9379L12.3354 14.6098L12.9379 15.6533H11.733L11.1306 16.6967L10.5281 15.6533H9.32324L9.92568 14.6098L9.32324 13.5663H10.5281L11.1306 12.5228Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:52234"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.000976562)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBq);
export default __webpack_public_path__ + "static/media/BQ.c92aa072.svg";
export { ForwardRef as ReactComponent };